import React from 'react'

function Contact() {
    return (
        <div id='contact'>
            <h3>We'd love to hear from you! Please write to us</h3>
            <div className='contact-input'>
                <input type='email' placeholder='marktwain@example.com'/>
                <a href='#'>Contact</a>
            </div>
        </div>
    )
}

export default Contact
